export default {
  no_items: 'Ничего не найдено',
  placeholder_search: 'Искать среди {{ total }}',
  no_request_result: 'По запросу «{{ request }}» ничего не найдено',
  no_filter_result: 'По выбранной фильтрации ничего не найдено',
  no_request_filter_result: 'По выбранной фильтрации и запросу «{{ request }}» ничего не найдено',
};
